import styled from "@emotion/styled";
import { useWallet } from "@solana/wallet-adapter-react";
import { greenSecondary } from "@stepfinance/react";
import { useLayoutEffect, useState } from "react";

import { ReactComponent as DisconnectIcon } from "../../assets/notifications/disconnectIcon.svg";
import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useLanguageContext } from "../../contexts/language/language";
import { notify } from "../../utils/notifications";
import { formatStringWithPlaceholders, shortenAddress } from "../../utils/utils";
import { activeWalletIcon, WatchedWalletIcon } from "../Icons";

export const ConnectedWalletNotifier = () => {
  const { connected, watching, publicKey } = useEnrichedWallet();
  const walletProviderInfo = useWallet();
  const [previousWallet, setPreviousWallet] = useState("");
  const {
    currentLanguageData: {
      pages: {
        allPages: { notifications },
      },
    },
  } = useLanguageContext();

  useLayoutEffect(() => {
    if (connected && publicKey) {
      const walletAddress = publicKey.toBase58();
      if (previousWallet !== walletAddress) {
        setPreviousWallet(walletAddress);
      }
      notify({
        type: "success",
        message: formatStringWithPlaceholders(
          watching ? notifications.watchingWallet.message : notifications.connectedToWallet.message,
          shortenAddress(walletAddress),
        ),
        icon: watching ? (
          <WatchedWalletIcon color={greenSecondary} height={24} width={24} />
        ) : walletProviderInfo.wallet?.adapter ? (
          <WalletIconContainer>{activeWalletIcon(walletProviderInfo.wallet?.adapter)}</WalletIconContainer>
        ) : null,
      });
    } else if (!connected && previousWallet.length) {
      notify({
        type: "success",
        message: formatStringWithPlaceholders(
          notifications.disconnectedToWallet.message,
          shortenAddress(previousWallet),
        ),
        icon: <DisconnectIcon />,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connected]);

  return <></>;
};

const WalletIconContainer = styled.div`
  img {
    width: 24px;
    height: 24px;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;
